<template>
  <div v-if="candidate" class="info-block">
    <div class="info-block__divider" />
    <p class="info-block__section-label">
      {{ $t('candidate') }}
    </p>
    <div class="info-row">
      <span class="info-row__value info-row__value--name">
        {{ candidate.firstName }} {{ candidate.lastName }}
      </span>
    </div>
    <div v-if="candidate.phone" class="info-row">
      <span class="info-row__label">{{ $t('phone') }}</span>
      <span class="info-row__value">{{ candidate.phone }}</span>
    </div>
    <div v-if="candidate.email" class="info-row">
      <span class="info-row__label">{{ $t('email') }}</span>
      <span class="info-row__value">{{ candidate.email }}</span>
    </div>
    <div v-if="candidate.resumeUrl" class="info-row info-row--resume">
      <a :href="candidate.resumeUrl" class="resume-link" target="_blank">
        <img src="../assets/img/icons/download.svg" width="14" height="14" alt="" />
        {{ $t('downloadResume') }}
      </a>
    </div>
  </div>
</template>

<script>
import useRoom from '@/compositions/useRoom';
import { computed } from '@vue/composition-api';

export default {
  name: 'VideoRoomEnterAdmin',
  setup() {
    const { existingRoom } = useRoom();

    return {
      candidate: computed(() => existingRoom.value?.candidate),
    };
  },
};
</script>

<style lang="scss" scoped>
.info-block {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  &__divider {
    height: 1px;
    background: #F0F4F8;
    margin: 0.25rem 0;
  }

  &__section-label {
    font-size: 0.7rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9BAEC4;
    margin: 0;
  }
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  &__label {
    font-size: 0.7rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9BAEC4;
  }

  &__value {
    font-size: 0.9375rem;
    color: #1A1A2E;

    &--name {
      font-size: 1.0625rem;
      font-weight: 500;
    }

    &--link {
      color: #0A82D9;
      text-decoration: none;
      transition: color 0.15s ease;

      &:hover {
        color: #0068B8;
        text-decoration: underline;
      }
    }
  }

  &--resume {
    margin-top: 0.25rem;
  }
}

.resume-link {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #0A82D9;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: #0068B8;
  }
}
</style>

<i18n locale="en" lang="yaml">
candidate: Candidate
phone: Phone
email: Email
downloadResume: Download resume
</i18n>

<i18n locale="ru" lang="yaml">
candidate: Кандидат
phone: Телефон
email: Email
downloadResume: Скачать резюме
</i18n>
